import { Component, Host, h, Fragment } from '@stencil/core';
import state from '@ugc-store';
import { toParse } from '@ugc-utils/utils';
// import { getStoreReview } from '@ugc-api/store-review';

@Component({
  tag: 'ugc-about-us',
  styleUrl: 'ugc-about-us.scss',
  shadow: false,
})
export class UgcAboutUs {
  // async componentWillLoad() {
  //   try {
  //     const storeReviewData = await getStoreReview();
  //     state.aboutUsList = storeReviewData;
  //   } catch (e) {}
  // }

  getStoreReview = () => {
    const {
      storeReviewStaticLanguage: {
        IDS_UGC_STORE_REVIEW_TITLE = '',
        IDS_UGC_READ_MORE_REVIEWS = '',
        IDS_UGC_STORE_REVIEWS_SWITCH = '',
      },
      isDesktop,
      domains: { catalog },
      aboutUsList,
    } = state;

    const isEnableStoreReviews = toParse(IDS_UGC_STORE_REVIEWS_SWITCH).EnableStoreReviews || false;

    if (!isEnableStoreReviews || !aboutUsList.length) return null;

    if (isDesktop) {
      return <about-us-slide />;
    }
    return (
      <div>
        <h3 class="m-0 ft-20 m-16">{IDS_UGC_STORE_REVIEW_TITLE}</h3>
        <about-us-slide />
        <div class="mt-8 text-center">
          <a
            href={`${catalog}/info/store-reviews`}
            class="hover-link-blue-dark pointer fs-16"
            data-ga-event-name="link_click"
            data-ga-interaction-type="store reviews"
            data-ga-location-detail="about us"
          >
            {IDS_UGC_READ_MORE_REVIEWS}
          </a>
        </div>
      </div>
    );
  };

  render() {
    const { isDesktop } = state;

    return (
      <Host class={{ 'ugc-global-css-wrap': true, isDesktop }}>
        <div class="ugc-component-wrap">
          {isDesktop ? (
            <about-us-banner>
              <div slot="about-us-store-review-summary">
                <about-us-store-review-summary />
              </div>
              {/* <div slot="about-us-store-review">{this.getStoreReview()}</div> */}
            </about-us-banner>
          ) : (
            <Fragment>
              <about-us-banner>
                <div slot="about-us-store-review-summary">
                  <about-us-store-review-summary />
                </div>
              </about-us-banner>
              {/* {this.getStoreReview()} */}
            </Fragment>
          )}
        </div>
      </Host>
    );
  }
}
